import React from 'react';
import { ShieldTickOutlinedIcon } from '@domain-group/fe-co-icon';
import { Badge } from '@domain-group/fe-blueprint-ui-x/badge';
import * as styles from './agent-profile-overview.style';

const ReinswMemberBadge = (): JSX.Element => (
  <div css={styles.badges}>
    <Badge family="accentThree">
      REINSW member
      <ShieldTickOutlinedIcon css={styles.reinswIcon} size="regular" />
    </Badge>
  </div>
);

export default ReinswMemberBadge;
